module.exports = __webpack_public_path__ + "static/media/Alliance Bank.94ee8ed8.svg";